import { render } from "./PEScore.vue?vue&type=template&id=55c45a8b&scoped=true"
import script from "./PEScore.vue?vue&type=script&lang=js"
export * from "./PEScore.vue?vue&type=script&lang=js"

import "./PEScore.vue?vue&type=style&index=0&id=55c45a8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c45a8b"]])

export default __exports__